import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
    margin: 0,
  },
});

export default useStyles;
